import styled from 'styled-components';
import SweetAlert2 from 'react-sweetalert2';
import { SweetAlertOptions } from 'sweetalert2';

interface IInputAttributes {
  [attribute: string]: string;
}

// type IInputAttributes = InputProps;
interface SweetAlert2Props extends SweetAlertOptions {
  show?: boolean;
  showLoading?: boolean;
  inputAttributes?: IInputAttributes;
  onConfirm?: any;
  onError?: any;
}

type IDialogProps = Omit<SweetAlert2Props, 'theme'>;

export const DialogContainer = styled(SweetAlert2)<IDialogProps>``;
